import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { TranslocoService } from '@jsverse/transloco';

import { MainNavSingleItemData } from '../../model/main-nav.model';
import { MainNavItemsService } from '../../services/main-nav-items.service';
import { MainNavService } from '../../services/main-nav.service';

@Component({
  selector: 'sh-main-nav-business-items-mobile',
  templateUrl: './main-nav-business-items-mobile.component.html',
  styleUrl: './main-nav-business-items-mobile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MainNavBusinessItemsMobileComponent {
  @Output() closeMenu = new EventEmitter();

  aboutUsOpen$ = new BehaviorSubject(false);

  get becomePartner(): MainNavSingleItemData {
    return {
      link: this.items.becomePartnerLink,
      title: `★ ${this.translocoService.translate(this.items.becomePartner.title)}`
    };
  }

  constructor(
    public items: MainNavItemsService,
    public nav: MainNavService,
    private translocoService: TranslocoService
  ) {}

  openAboutUs() {
    this.aboutUsOpen$.next(true);
  }

  closeAboutUs() {
    this.aboutUsOpen$.next(false);
  }

  onCloseMenu() {
    this.closeMenu.emit();
  }
}
